package br.com.vvrefeicoes.portal.feature.companies

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.FlowRowScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.ui.components.AppBadge
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppPagination
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppTooltipText
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SearchableSelect
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.ui.theme.LocalAppExtraColors
import br.com.vvrefeicoes.portal.core.util.MonthCalendar
import br.com.vvrefeicoes.portal.core.util.SystemDateTimeProvider
import br.com.vvrefeicoes.portal.core.util.openPublicMonitor
import br.com.vvrefeicoes.portal.domain.model.Company
import br.com.vvrefeicoes.portal.domain.model.CompanyEmotion
import br.com.vvrefeicoes.portal.domain.model.CompanyService
import br.com.vvrefeicoes.portal.domain.model.CompanyServiceDraft
import br.com.vvrefeicoes.portal.domain.model.CompanyType
import br.com.vvrefeicoes.portal.domain.model.MonitorCode
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.domain.model.allows
import br.com.vvrefeicoes.portal.navigation.OrgChartRoute
import com.composables.icons.lucide.Ban
import com.composables.icons.lucide.Building
import com.composables.icons.lucide.Check
import com.composables.icons.lucide.Download
import com.composables.icons.lucide.EllipsisVertical
import com.composables.icons.lucide.Eye
import com.composables.icons.lucide.EyeOff
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Monitor
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Plus
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.Smile
import com.composables.icons.lucide.Tag
import com.composables.icons.lucide.Trash2
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.companies_action_activate
import portalvv.shared.generated.resources.companies_action_deactivate
import portalvv.shared.generated.resources.companies_action_details
import portalvv.shared.generated.resources.companies_action_edit
import portalvv.shared.generated.resources.companies_add
import portalvv.shared.generated.resources.companies_cancel
import portalvv.shared.generated.resources.companies_cep_loading
import portalvv.shared.generated.resources.companies_col_actions
import portalvv.shared.generated.resources.companies_col_direction
import portalvv.shared.generated.resources.companies_col_legal_name
import portalvv.shared.generated.resources.companies_col_management
import portalvv.shared.generated.resources.companies_col_trade_name
import portalvv.shared.generated.resources.companies_col_type
import portalvv.shared.generated.resources.companies_col_updated_at
import portalvv.shared.generated.resources.companies_col_updated_by
import portalvv.shared.generated.resources.companies_deactivate_confirm
import portalvv.shared.generated.resources.companies_deactivate_msg
import portalvv.shared.generated.resources.companies_deactivate_title
import portalvv.shared.generated.resources.companies_details_title
import portalvv.shared.generated.resources.companies_empty
import portalvv.shared.generated.resources.companies_export
import portalvv.shared.generated.resources.companies_field_admin_others_percent
import portalvv.shared.generated.resources.companies_field_button_count
import portalvv.shared.generated.resources.companies_field_cep
import portalvv.shared.generated.resources.companies_field_city
import portalvv.shared.generated.resources.companies_field_cnpj
import portalvv.shared.generated.resources.companies_field_comment_all_ratings
import portalvv.shared.generated.resources.companies_field_commercial_phone
import portalvv.shared.generated.resources.companies_field_direction
import portalvv.shared.generated.resources.companies_field_email
import portalvv.shared.generated.resources.companies_field_employee_count
import portalvv.shared.generated.resources.companies_field_leftover_meals
import portalvv.shared.generated.resources.companies_field_legal_name
import portalvv.shared.generated.resources.companies_field_line
import portalvv.shared.generated.resources.companies_field_logo
import portalvv.shared.generated.resources.companies_field_long_auto_send_time
import portalvv.shared.generated.resources.companies_field_management
import portalvv.shared.generated.resources.companies_field_mobile_phone
import portalvv.shared.generated.resources.companies_field_neighborhood
import portalvv.shared.generated.resources.companies_field_number
import portalvv.shared.generated.resources.companies_field_short_auto_send_time
import portalvv.shared.generated.resources.companies_field_state
import portalvv.shared.generated.resources.companies_field_street
import portalvv.shared.generated.resources.companies_field_trade_name
import portalvv.shared.generated.resources.companies_field_type
import portalvv.shared.generated.resources.companies_form_add_title
import portalvv.shared.generated.resources.companies_form_edit_title
import portalvv.shared.generated.resources.companies_go_to_org_chart
import portalvv.shared.generated.resources.companies_inactive
import portalvv.shared.generated.resources.companies_invalid_number
import portalvv.shared.generated.resources.companies_invalid_percent
import portalvv.shared.generated.resources.companies_management_hint
import portalvv.shared.generated.resources.companies_more_names
import portalvv.shared.generated.resources.companies_none
import portalvv.shared.generated.resources.companies_only_active
import portalvv.shared.generated.resources.companies_retry
import portalvv.shared.generated.resources.companies_save
import portalvv.shared.generated.resources.companies_search_placeholder
import portalvv.shared.generated.resources.companies_service_add
import portalvv.shared.generated.resources.companies_service_cancel
import portalvv.shared.generated.resources.companies_service_daily_quantity
import portalvv.shared.generated.resources.companies_service_delete
import portalvv.shared.generated.resources.companies_service_delete_confirm
import portalvv.shared.generated.resources.companies_service_edit
import portalvv.shared.generated.resources.companies_service_end
import portalvv.shared.generated.resources.companies_service_name
import portalvv.shared.generated.resources.companies_service_save
import portalvv.shared.generated.resources.companies_service_start
import portalvv.shared.generated.resources.companies_services_empty
import portalvv.shared.generated.resources.companies_services_hide
import portalvv.shared.generated.resources.companies_services_loading
import portalvv.shared.generated.resources.companies_services_show
import portalvv.shared.generated.resources.companies_title
import portalvv.shared.generated.resources.companies_type_eventos
import portalvv.shared.generated.resources.companies_type_loj
import portalvv.shared.generated.resources.companies_type_tra
import portalvv.shared.generated.resources.companies_type_upr

private val WeightTrade = 1.6f
private val WeightLegal = 2f
private val WeightType = 1f
private val WeightDirection = 1.4f
private val WeightManagement = 1.4f
private val WeightUpdatedBy = 1.2f
private val WeightUpdatedAt = 1.2f
private val WeightActions = 0.6f
private val LineOptions = (0..5).map(Int::toString)

@Composable
fun CompaniesScreen(onNavigate: (Any) -> Unit = {}) {
    val controller = rememberCompaniesController()
    val permissions = rememberSessionPermissions()
    val unitsKey = PermissionKeys.COMPANIES
    val canCreate = permissions.allows(unitsKey, PermissionAction.CREATE)
    val canEdit = permissions.allows(unitsKey, PermissionAction.EDIT)

    LaunchedEffect(controller) {
        controller.init()
    }

    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        footer = { AppFooter() },
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Text(
                text = stringResource(Res.string.companies_title),
                style = MaterialTheme.typography.headlineMedium,
                modifier = Modifier.weight(1f),
            )
            if (canEdit) {
                AppButton(
                    text = "Linhas",
                    onClick = controller::openLineCatalog,
                    leadingIcon = Lucide.Tag,
                    variant = PortalButtonVariant.Outlined,
                )
                AppButton(
                    text = if (controller.syncingFromSatisfaction) "Importando..." else "Importar dados faltantes",
                    onClick = controller::syncMissingFromSatisfaction,
                    enabled = !controller.syncingFromSatisfaction,
                    leadingIcon = Lucide.Download,
                )
            }
        }

        controller.errorMessage?.let { message ->
            Surface(
                modifier = Modifier.fillMaxWidth(),
                color = MaterialTheme.colorScheme.errorContainer,
                shape = AppShapes.medium,
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Text(
                        text = message,
                        color = MaterialTheme.colorScheme.onErrorContainer,
                        modifier = Modifier.weight(1f),
                    )
                    AppButton(
                        text = stringResource(Res.string.companies_retry),
                        onClick = controller::retry,
                        variant = PortalButtonVariant.Outlined,
                    )
                }
            }
        }

        controller.lastMissingSync?.let { result ->
            Surface(
                modifier = Modifier.fillMaxWidth(),
                color = MaterialTheme.colorScheme.secondaryContainer,
                shape = AppShapes.medium,
            ) {
                Text(
                    text = "Importação concluída: ${result.companiesCreated} empresas, ${result.servicesCreated} serviços, ${result.linesCreated} linhas e ${result.associationsCreated} associações novas.",
                    modifier = Modifier.padding(AppSpacing.space12),
                    color = MaterialTheme.colorScheme.onSecondaryContainer,
                )
            }
        }

        FiltersCard(controller = controller, canCreate = canCreate)

        if (controller.loading) {
            Box(
                modifier = Modifier.fillMaxWidth().height(240.dp),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        } else {
            CompaniesCards(controller = controller, canEdit = canEdit, onNavigate = onNavigate)
            AppPagination(
                page = controller.page,
                pageCount = controller.pageCount,
                onPageChange = controller::goToPage,
                modifier = Modifier.align(Alignment.End),
            )
            CostCentersSection(controller = controller, canCreate = canCreate, canEdit = canEdit)
        }
    }

    controller.formMode?.let { mode ->
        CompanyFormDialog(mode = mode, controller = controller, onNavigate = onNavigate)
    }

    controller.detailsCompany?.let { company ->
        CompanyDetailsDialog(company = company, onDismiss = controller::dismissDetails)
    }

    controller.deactivateTarget?.let { company ->
        ConfirmDialog(
            title = stringResource(Res.string.companies_deactivate_title),
            message = stringResource(Res.string.companies_deactivate_msg),
            confirmLabel = stringResource(Res.string.companies_deactivate_confirm),
            onConfirm = controller::confirmDeactivate,
            onDismiss = controller::dismissDeactivate,
        )
    }

    controller.serviceDialogCompanyId?.let { companyId ->
        CompanyServiceFormDialog(
            controller = controller,
            companyId = companyId,
            service = controller.serviceDialogService,
        )
    }

    controller.emotionCompanyId?.let { companyId ->
        EmotionDialog(
            company = controller.companies.firstOrNull { it.id == companyId },
            controller = controller,
        )
    }

    controller.serviceDeleteTarget?.let {
        ConfirmDialog(
            title = stringResource(Res.string.companies_service_delete),
            message = stringResource(Res.string.companies_service_delete_confirm),
            confirmLabel = stringResource(Res.string.companies_service_delete),
            onConfirm = controller::confirmDeleteService,
            onDismiss = controller::dismissDeleteService,
        )
    }

    if (controller.costCenterCompanyId != null) {
        CostCenterFormDialog(controller)
    }

    if (controller.lineCatalogOpen) {
        LinesCatalogDialog(controller)
    }

    if (controller.lineDialogOpen) {
        LineFormDialog(controller)
    }
}

@Composable
private fun LinesCatalogDialog(controller: CompaniesController) {
    AppModalCard(
        title = "Linhas de serviço",
        onDismiss = controller::dismissLineCatalog,
    ) {
        Text(
            text = "Catálogo sincronizado com o Satisfaction",
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.End,
        ) {
            AppButton("Adicionar linha", controller::openAddLine, leadingIcon = Lucide.Plus)
        }
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            controller.lines.forEach { line ->
                Row(
                    modifier = Modifier.fillMaxWidth().background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.35f)).padding(AppSpacing.space8),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        Text(line.name, style = MaterialTheme.typography.bodyMedium)
                        Text(line.code, style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                    }
                    if (line.isDefault) Text("Padrão", style = MaterialTheme.typography.labelSmall, color = MaterialTheme.colorScheme.primary)
                    IconButton(onClick = { controller.openEditLine(line) }) {
                        Icon(Lucide.Pencil, contentDescription = "Editar linha")
                    }
                    IconButton(onClick = { controller.deactivateLine(line) }) {
                        Icon(Lucide.Ban, contentDescription = "Desativar linha")
                    }
                }
            }
        }
    }
}

@Composable
private fun LineFormDialog(controller: CompaniesController) {
    AppModalCard(
        title = if (controller.lineDialogLine == null) "Adicionar linha" else "Editar linha",
        onDismiss = controller::dismissLineForm,
    ) {
        AppTextField(controller.lineFormCode, { controller.lineFormCode = it }, "Código", Modifier.fillMaxWidth())
        AppTextField(controller.lineFormName, { controller.lineFormName = it }, "Nome", Modifier.fillMaxWidth())
        AppTextField(controller.lineFormDisplayOrder, { controller.lineFormDisplayOrder = it }, "Ordem", Modifier.fillMaxWidth())
        Row(verticalAlignment = Alignment.CenterVertically) {
            Checkbox(controller.lineFormDefault, { controller.lineFormDefault = it })
            Text("Linha padrão")
        }
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End)) {
            AppButton("Cancelar", controller::dismissLineForm, variant = PortalButtonVariant.Outlined)
            AppButton(
                "Salvar",
                controller::saveLine,
                enabled = !controller.lineBusy && controller.lineFormCode.isNotBlank() && controller.lineFormName.isNotBlank(),
            )
        }
    }
}

@Composable
private fun CostCentersSection(
    controller: CompaniesController,
    canCreate: Boolean,
    canEdit: Boolean,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
                Column(modifier = Modifier.weight(1f)) {
                    Text("Centros de custo", style = MaterialTheme.typography.titleMedium)
                    Text("Registros vinculados às unidades", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }
                if (canCreate && controller.companies.isNotEmpty()) {
                    AppButton("Adicionar", { controller.openAddCostCenter(controller.companies.first().id) }, leadingIcon = Lucide.Plus)
                }
            }
            if (controller.costCenters.isEmpty()) {
                Text("Nenhum registro de centro de custo.", color = MaterialTheme.colorScheme.onSurfaceVariant)
            } else {
                val companyNames = remember(controller.companies) { controller.companies.associate { it.id to it.name } }
                controller.costCenters.forEach { center ->
                    val companyName = companyNames[center.companyId] ?: center.companyId
                    Row(
                        modifier = Modifier.fillMaxWidth().background(MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.35f)).padding(AppSpacing.space12),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                    ) {
                        Column(modifier = Modifier.weight(1f)) {
                            Text(center.name, style = MaterialTheme.typography.bodyLarge)
                            Text("$companyName${center.code.takeIf { it.isNotBlank() }?.let { " • $it" } ?: ""}", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                        }
                        AppBadge(
                            text = if (center.active) "Ativo" else "Inativo",
                            containerColor = if (center.active) AppPalette.Success100 else AppPalette.Neutral200,
                            contentColor = if (center.active) AppPalette.Success900 else AppPalette.Neutral900,
                        )
                        if (canEdit) {
                            IconButton(onClick = { controller.openEditCostCenter(center) }) { Icon(Lucide.Pencil, contentDescription = "Editar") }
                            IconButton(
                                onClick = { if (center.active) controller.deleteCostCenter(center) else controller.toggleCostCenter(center) },
                            ) {
                                Icon(if (center.active) Lucide.Ban else Lucide.Check, contentDescription = if (center.active) "Inativar" else "Reativar")
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun CostCenterFormDialog(controller: CompaniesController) {
    AppModalCard(
        title = if (controller.costCenterDialog == null) "Adicionar centro de custo" else "Editar centro de custo",
        onDismiss = controller::dismissCostCenterForm,
    ) {
        SearchableSelect(
            leadingIcon = Lucide.Building,
            options = controller.companies.map { it.name },
            selected =
                controller.companies
                    .firstOrNull { it.id == controller.costCenterCompanyId }
                    ?.name
                    .orEmpty(),
            onSelect = { name ->
                controller.companies
                    .firstOrNull { it.name == name }
                    ?.id
                    ?.let(controller::selectCostCenterCompany)
            },
            modifier = Modifier.fillMaxWidth(),
        )
        AppTextField(controller.costCenterName, { controller.costCenterName = it }, "Nome", Modifier.fillMaxWidth())
        AppTextField(controller.costCenterCode, { controller.costCenterCode = it }, "Código (opcional)", Modifier.fillMaxWidth())
        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
            AppButton("Cancelar", controller::dismissCostCenterForm, variant = PortalButtonVariant.Outlined)
            AppButton("Salvar", controller::submitCostCenter, enabled = controller.costCenterName.isNotBlank() && !controller.costCenterBusy)
        }
    }
}

@Composable
private fun FiltersCard(
    controller: CompaniesController,
    canCreate: Boolean,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            AppTextField(
                value = controller.query,
                onValueChange = controller::updateQuery,
                placeholder = stringResource(Res.string.companies_search_placeholder),
                leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
                modifier = Modifier.weight(1f),
            )
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                Switch(checked = controller.onlyActive, onCheckedChange = controller::updateOnlyActive)
                Text(
                    text = stringResource(Res.string.companies_only_active),
                    style = MaterialTheme.typography.bodyMedium,
                )
            }
            AppButton(
                text = stringResource(Res.string.companies_export),
                onClick = {},
                variant = PortalButtonVariant.Outlined,
                leadingIcon = Lucide.Download,
            )
            if (canCreate) {
                AppButton(
                    text = stringResource(Res.string.companies_add),
                    onClick = controller::openAdd,
                    leadingIcon = Lucide.Plus,
                )
            }
        }
    }
}

@Composable
private fun CompaniesCards(
    controller: CompaniesController,
    canEdit: Boolean,
    onNavigate: (Any) -> Unit,
) {
    if (controller.paged.isEmpty()) {
        EmptyState(message = stringResource(Res.string.companies_empty))
        return
    }

    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val columns =
            when {
                maxWidth < 680.dp -> 1
                maxWidth < 1080.dp -> 2
                else -> 3
            }
        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            maxItemsInEachRow = columns,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            controller.paged.forEach { company ->
                CompanyCard(company = company, controller = controller, canEdit = canEdit, onNavigate = onNavigate)
            }
        }
    }
}

@Composable
private fun FlowRowScope.CompanyCard(
    company: Company,
    controller: CompaniesController,
    canEdit: Boolean,
    onNavigate: (Any) -> Unit,
) {
    val muted = company.inactive
    Surface(
        modifier = Modifier.fillMaxWidth().weight(1f),
        shape = AppShapes.large,
        color = if (muted) MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.45f) else MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.Top,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
            ) {
                Icon(
                    imageVector = Lucide.Building,
                    contentDescription = null,
                    tint = if (muted) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.primary,
                )
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = company.name,
                        style = MaterialTheme.typography.titleMedium,
                        color = if (muted) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.onSurface,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                    )
                    Text(
                        text = company.legalName,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
                Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                    IconButton(
                        onClick = { openPublicMonitor(MonitorCode.fromCompanyId(company.id)) },
                        modifier = Modifier.size(24.dp),
                    ) {
                        Icon(Lucide.Monitor, contentDescription = "Abrir monitor")
                    }
                    CompanyActionsMenu(company = company, controller = controller, canEdit = canEdit)
                }
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                val colors = company.type.badgeColors()
                AppBadge(text = company.type.label(), containerColor = colors.first, contentColor = colors.second)
                if (muted) {
                    AppBadge(
                        text = stringResource(Res.string.companies_inactive),
                        containerColor = AppPalette.Neutral200,
                        contentColor = AppPalette.Neutral900,
                    )
                }
            }

            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)

            CompanyCardInfo(
                label = stringResource(Res.string.companies_col_direction),
                value = namesLabel(company.directorNames).ifBlank { stringResource(Res.string.companies_none) },
            )
            CompanyCardInfo(
                label = stringResource(Res.string.companies_col_management),
                value = namesLabel(company.managerNames).ifBlank { stringResource(Res.string.companies_none) },
            )
            CompanyCardInfo(
                label = stringResource(Res.string.companies_col_updated_at),
                value = formatUpdatedAt(company.updatedAt).ifBlank { stringResource(Res.string.companies_none) },
            )

            AppButton(
                text =
                    if (controller.expandedCompanyId == company.id) {
                        stringResource(Res.string.companies_services_hide)
                    } else {
                        stringResource(Res.string.companies_services_show)
                    },
                onClick = { controller.toggleServices(company.id) },
                variant = PortalButtonVariant.Text,
            )

            if (controller.expandedCompanyId == company.id) {
                CompanyServices(
                    companyId = company.id,
                    services = controller.servicesByCompany[company.id].orEmpty(),
                    loading = controller.loadingServicesFor == company.id,
                    canEdit = canEdit && !muted,
                    controller = controller,
                )
            }
        }
    }
}

@Composable
private fun CompanyServices(
    companyId: String,
    services: List<CompanyService>,
    loading: Boolean,
    canEdit: Boolean,
    controller: CompaniesController,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
        HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
        if (canEdit) {
            AppButton(
                text = stringResource(Res.string.companies_service_add),
                onClick = { controller.openAddService(companyId) },
                variant = PortalButtonVariant.Text,
                leadingIcon = Lucide.Plus,
            )
        }
        when {
            loading ->
                Text(
                    text = stringResource(Res.string.companies_services_loading),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            services.isEmpty() ->
                Text(
                    text = stringResource(Res.string.companies_services_empty),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            else ->
                services.forEach { service ->
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                    ) {
                        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                            Text(text = service.name, style = MaterialTheme.typography.bodyMedium)
                            Text(
                                text = "${service.dailyQuantity}/dia | ${service.startTime} - ${service.endTime}",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                            )
                            Text(
                                text = "R$ ${formatServicePrice(service.price)}",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.primary,
                            )
                            if (service.lines.isNotEmpty()) {
                                Text(
                                    text = service.lines.joinToString { it.name },
                                    style = MaterialTheme.typography.bodySmall,
                                    color = MaterialTheme.colorScheme.primary,
                                )
                            }
                        }
                        if (canEdit) {
                            IconButton(onClick = { controller.openEditService(companyId, service) }) {
                                Icon(Lucide.Pencil, contentDescription = stringResource(Res.string.companies_service_edit))
                            }
                            IconButton(onClick = { controller.requestDeleteService(companyId, service.id) }) {
                                Icon(Lucide.Trash2, contentDescription = stringResource(Res.string.companies_service_delete))
                            }
                        }
                    }
                }
        }
    }
}

@Composable
private fun CompanyServiceFormDialog(
    controller: CompaniesController,
    companyId: String,
    service: CompanyService?,
) {
    val currentYear = SystemDateTimeProvider().today().year
    val defaultActiveDays =
        (1..12).associate { month ->
            month.toString() to (1..MonthCalendar.daysInMonth(currentYear, month)).toList()
        }
    val initial =
        service?.let {
            CompanyServiceDraft(
                serviceType = it.serviceType,
                name = it.name,
                startTime = it.startTime,
                endTime = it.endTime,
                price = formatServicePrice(it.price),
                quantity = it.quantity,
                mondayQuantity = it.mondayQuantity,
                tuesdayQuantity = it.tuesdayQuantity,
                wednesdayQuantity = it.wednesdayQuantity,
                thursdayQuantity = it.thursdayQuantity,
                fridayQuantity = it.fridayQuantity,
                saturdayQuantity = it.saturdayQuantity,
                sundayQuantity = it.sundayQuantity,
                sundayActive = it.sundayActive,
                dailyQuantity = it.dailyQuantity,
                activeDays = it.activeDays.ifEmpty { defaultActiveDays },
                lineIds = it.lines.map { line -> line.id },
            )
        } ?: CompanyServiceDraft(
            serviceType = "",
            name = "",
            startTime = "",
            endTime = "",
            price = "",
            activeDays = defaultActiveDays,
        )
    var draft by remember(service?.id) { mutableStateOf(initial) }
    var selectedMonth by remember { mutableStateOf("1") }
    val serviceTypeName = controller.serviceTypes.firstOrNull { it.id == draft.serviceType }?.name ?: draft.serviceType
    val update: (CompanyServiceDraft) -> Unit = { draft = it }
    val months = listOf("Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro")
    val monthNumber = selectedMonth.toInt()
    val year = currentYear
    val firstDayOffset = (LocalDate(year, monthNumber, 1).dayOfWeek.ordinal + 1) % 7
    val daysInMonth = MonthCalendar.daysInMonth(year, monthNumber)
    val activeDays = draft.activeDays[selectedMonth].orEmpty()
    val extraColors = LocalAppExtraColors.current

    AppModalCard(
        title = stringResource(if (service == null) Res.string.companies_service_add else Res.string.companies_service_edit),
        onDismiss = controller::dismissServiceForm,
    ) {
        SearchableSelect(
            leadingIcon = Lucide.Tag,
            options = controller.serviceTypes.map { it.name },
            selected = serviceTypeName,
            onSelect = { selected -> update(draft.copy(serviceType = controller.serviceTypes.firstOrNull { it.name == selected }?.id ?: draft.serviceType)) },
            modifier = Modifier.fillMaxWidth(),
        )
        AppTextField(draft.name, { update(draft.copy(name = it)) }, stringResource(Res.string.companies_service_name), Modifier.fillMaxWidth())
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
            AppTextField(draft.startTime, { update(draft.copy(startTime = it)) }, stringResource(Res.string.companies_service_start), Modifier.weight(1f))
            AppTextField(draft.endTime, { update(draft.copy(endTime = it)) }, stringResource(Res.string.companies_service_end), Modifier.weight(1f))
        }
        AppTextField(
            draft.price,
            { update(draft.copy(price = it)) },
            "Preço do serviço (R$)",
            Modifier.fillMaxWidth(),
        )
        AppTextField(
            draft.dailyQuantity.toString(),
            { update(draft.copy(dailyQuantity = it.toIntOrNull() ?: 0, quantity = it.toIntOrNull() ?: 0)) },
            stringResource(Res.string.companies_service_daily_quantity),
            Modifier.fillMaxWidth(),
        )
        Text(
            text = "Quantidade por dia da semana",
            style = MaterialTheme.typography.labelLarge,
        )
        if (controller.lines.isNotEmpty()) {
            Text(text = "Linhas do serviço", style = MaterialTheme.typography.labelLarge)
            Column {
                controller.lines.forEach { line ->
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Checkbox(
                            checked = line.id in draft.lineIds,
                            onCheckedChange = { checked ->
                                val next = if (checked) draft.lineIds + line.id else draft.lineIds - line.id
                                update(draft.copy(lineIds = next.distinct()))
                            },
                        )
                        Text(line.name)
                    }
                }
            }
        }
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            AppTextField(draft.mondayQuantity.toString(), { update(draft.copy(mondayQuantity = it.toIntOrNull() ?: 0)) }, "Seg", Modifier.weight(1f))
            AppTextField(draft.tuesdayQuantity.toString(), { update(draft.copy(tuesdayQuantity = it.toIntOrNull() ?: 0)) }, "Ter", Modifier.weight(1f))
            AppTextField(draft.wednesdayQuantity.toString(), { update(draft.copy(wednesdayQuantity = it.toIntOrNull() ?: 0)) }, "Qua", Modifier.weight(1f))
        }
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            AppTextField(draft.thursdayQuantity.toString(), { update(draft.copy(thursdayQuantity = it.toIntOrNull() ?: 0)) }, "Qui", Modifier.weight(1f))
            AppTextField(draft.fridayQuantity.toString(), { update(draft.copy(fridayQuantity = it.toIntOrNull() ?: 0)) }, "Sex", Modifier.weight(1f))
            AppTextField(draft.saturdayQuantity.toString(), { update(draft.copy(saturdayQuantity = it.toIntOrNull() ?: 0)) }, "Sab", Modifier.weight(1f))
        }
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            AppTextField(draft.sundayQuantity.toString(), { update(draft.copy(sundayQuantity = it.toIntOrNull() ?: 0)) }, "Dom", Modifier.weight(1f))
            Text(
                text = "Dias ativos do mês",
                style = MaterialTheme.typography.labelLarge,
                modifier = Modifier.weight(2f),
            )
        }
        SearchableSelect(
            leadingIcon = Lucide.Tag,
            options = months,
            selected = months[monthNumber - 1],
            onSelect = { selectedMonth = (months.indexOf(it) + 1).toString() },
            modifier = Modifier.fillMaxWidth(),
        )
        Text("Dias ativos do mês", style = MaterialTheme.typography.labelLarge)
        FlowRow(
            maxItemsInEachRow = 7,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space4),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
        ) {
            repeat(firstDayOffset) { Spacer(Modifier.width(34.dp).height(34.dp)) }
            (1..daysInMonth).forEach { day ->
                val selected = day in activeDays
                Surface(
                    onClick = {
                        val nextDays = if (selected) activeDays - day else (activeDays + day).sorted()
                        update(draft.copy(activeDays = draft.activeDays + (selectedMonth to nextDays)))
                    },
                    modifier = Modifier.size(34.dp),
                    shape = AppShapes.small,
                    color = if (selected) extraColors.successContainer else AppPalette.Neutral200,
                    contentColor = if (selected) extraColors.onSuccessContainer else AppPalette.Neutral500,
                ) {
                    Box(contentAlignment = Alignment.Center) {
                        Text(day.toString(), style = MaterialTheme.typography.labelSmall)
                    }
                }
            }
        }
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End)) {
            AppButton(
                text = stringResource(Res.string.companies_service_cancel),
                onClick = controller::dismissServiceForm,
                variant = PortalButtonVariant.Outlined,
            )
            AppButton(
                text = stringResource(Res.string.companies_service_save),
                onClick = {
                    val lineIds =
                        draft.lineIds.ifEmpty {
                            controller.lines
                                .firstOrNull { it.isDefault }
                                ?.let { listOf(it.id) }
                                .orEmpty()
                        }
                    controller.submitService(companyId, service?.id, draft.copy(lineIds = lineIds))
                },
                enabled = draft.serviceType.isNotBlank() && draft.name.isNotBlank() && draft.startTime.isNotBlank() && draft.endTime.isNotBlank() && (draft.price.replace(',', '.').toDoubleOrNull() ?: 0.0) > 0.0,
            )
        }
    }
}

private fun formatServicePrice(value: Double): String {
    val normalized = value.toString().replace('.', ',')
    val separator = normalized.indexOf(',')
    if (separator < 0) return "$normalized,00"
    val decimals = normalized.length - separator - 1
    return when {
        decimals == 0 -> "${normalized}00"
        decimals == 1 -> "${normalized}0"
        else -> normalized.substring(0, separator + 3)
    }
}

private fun formatServicePrice(
    value: String,
): String = value.replace(',', '.').toDoubleOrNull()?.let(::formatServicePrice) ?: value

@Composable
private fun CompanyCardInfo(
    label: String,
    value: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = value,
            style = MaterialTheme.typography.bodyMedium,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
        )
    }
}

@Composable
private fun CompaniesHeaderRow() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        HeaderCell(stringResource(Res.string.companies_col_trade_name), WeightTrade)
        HeaderCell(stringResource(Res.string.companies_col_legal_name), WeightLegal)
        HeaderCell(stringResource(Res.string.companies_col_type), WeightType)
        HeaderCell(stringResource(Res.string.companies_col_direction), WeightDirection)
        HeaderCell(stringResource(Res.string.companies_col_management), WeightManagement)
        HeaderCell(stringResource(Res.string.companies_col_updated_by), WeightUpdatedBy)
        HeaderCell(stringResource(Res.string.companies_col_updated_at), WeightUpdatedAt)
        HeaderCell(stringResource(Res.string.companies_col_actions), WeightActions)
    }
}

@Composable
private fun RowScope.HeaderCell(
    text: String,
    weight: Float,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun CompanyRow(
    company: Company,
    controller: CompaniesController,
    canEdit: Boolean,
) {
    val muted = company.inactive
    val rowColor = if (muted) MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.4f) else Color.Transparent
    Row(
        modifier =
            Modifier
                .fillMaxWidth()
                .background(rowColor)
                .padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        Row(
            modifier = Modifier.weight(WeightTrade),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            AppTooltipText(
                text = company.name,
                style = MaterialTheme.typography.bodyMedium,
                color = if (muted) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.onSurface,
                modifier = Modifier.weight(1f, fill = false),
            )
            if (muted) {
                AppBadge(
                    text = stringResource(Res.string.companies_inactive),
                    containerColor = AppPalette.Neutral200,
                    contentColor = AppPalette.Neutral900,
                )
            }
        }
        BodyCell(company.legalName, WeightLegal, muted)
        Box(modifier = Modifier.weight(WeightType)) {
            val colors = company.type.badgeColors()
            AppBadge(
                text = company.type.label(),
                containerColor = colors.first,
                contentColor = colors.second,
            )
        }
        BodyCell(namesLabel(company.directorNames), WeightDirection, muted)
        BodyCell(namesLabel(company.managerNames), WeightManagement, muted)
        BodyCell(company.updatedBy, WeightUpdatedBy, muted)
        BodyCell(formatUpdatedAt(company.updatedAt), WeightUpdatedAt, muted)
        Box(modifier = Modifier.weight(WeightActions)) {
            CompanyActionsMenu(company = company, controller = controller, canEdit = canEdit)
        }
    }
}

@Composable
private fun namesLabel(names: List<String>): String =
    when {
        names.isEmpty() -> ""
        names.size <= 2 -> names.joinToString(", ")
        else -> "${names[0]}, ${names[1]} ${stringResource(Res.string.companies_more_names, names.size - 2)}"
    }

@Composable
private fun RowScope.BodyCell(
    text: String,
    weight: Float,
    muted: Boolean = false,
) {
    AppTooltipText(
        text = text,
        style = MaterialTheme.typography.bodyMedium,
        color =
            if (muted) {
                MaterialTheme.colorScheme.onSurfaceVariant
            } else {
                MaterialTheme.colorScheme.onSurface
            },
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun CompanyActionsMenu(
    company: Company,
    controller: CompaniesController,
    canEdit: Boolean,
) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        IconButton(
            onClick = { expanded = true },
            modifier = Modifier.size(24.dp),
        ) {
            Icon(
                imageVector = Lucide.EllipsisVertical,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.companies_action_details)) },
                leadingIcon = { Icon(Lucide.Eye, contentDescription = null) },
                onClick = {
                    expanded = false
                    controller.openDetails(company)
                },
            )
            if (canEdit) {
                if (!company.inactive) {
                    DropdownMenuItem(
                        text = { Text("Configurar emoticons") },
                        leadingIcon = { Icon(Lucide.Smile, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.openEmotions(company.id)
                        },
                    )
                    DropdownMenuItem(
                        text = { Text(stringResource(Res.string.companies_action_edit)) },
                        leadingIcon = { Icon(Lucide.Pencil, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.openEdit(company)
                        },
                    )
                    DropdownMenuItem(
                        text = { Text(stringResource(Res.string.companies_action_deactivate)) },
                        leadingIcon = { Icon(Lucide.Ban, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.requestDeactivate(company)
                        },
                    )
                } else {
                    DropdownMenuItem(
                        text = { Text(stringResource(Res.string.companies_action_activate)) },
                        leadingIcon = { Icon(Lucide.Check, contentDescription = null) },
                        onClick = {
                            expanded = false
                            controller.activate(company)
                        },
                    )
                }
            }
        }
    }
}

@Composable
private fun EmotionDialog(
    company: Company?,
    controller: CompaniesController,
) {
    AppModalCard(
        title = "Emoticons${company?.name?.let { " • $it" } ?: ""}",
        onDismiss = controller::dismissEmotions,
    ) {
        if (controller.emotionLoading) {
            Box(
                modifier = Modifier.fillMaxWidth().padding(AppSpacing.space24),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        } else {
            Text(
                text = "Escolha os emoticons exibidos no aplicativo.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                controller.emotionCatalog.forEach { emotion ->
                    EmotionOption(emotion, controller, controller.selectedEmotions.firstOrNull { it.id == emotion.id })
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
            ) {
                AppButton(
                    text = "Salvar emoticons",
                    onClick = controller::saveEmotions,
                    enabled = !controller.emotionBusy,
                    leadingIcon = Lucide.Check,
                )
            }
        }
    }
}

@Composable
private fun EmotionOption(
    emotion: CompanyEmotion,
    controller: CompaniesController,
    configured: CompanyEmotion?,
) {
    val customResponses = configured?.responses?.filter { it.custom }.orEmpty()
    val responseLimitReached = customResponses.size >= 5

    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Checkbox(
                checked = emotion.id in controller.selectedEmotionIds,
                onCheckedChange = { controller.toggleEmotion(emotion.id, it) },
            )
            Text(text = emotion.emoji, style = MaterialTheme.typography.titleLarge)
            Column(modifier = Modifier.weight(1f)) {
                Text(text = emotion.name, style = MaterialTheme.typography.bodyMedium)
                Text(
                    text = "${customResponses.size}/5 respostas personalizadas",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }
        if (configured != null) {
            configured.responses.filter { it.custom }.forEach { response ->
                if (controller.editingEmotionResponseId == response.id) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(start = AppSpacing.space48),
                        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        AppTextField(
                            value = controller.editingEmotionResponseText,
                            onValueChange = { controller.editingEmotionResponseText = it },
                            label = "Resposta",
                            modifier = Modifier.weight(1f),
                        )
                        AppButton(text = "Salvar", onClick = controller::saveEmotionResponse)
                        AppButton(text = "Cancelar", onClick = controller::cancelEditEmotionResponse, variant = PortalButtonVariant.Text)
                    }
                } else {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(start = AppSpacing.space48),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Text(text = response.text, style = MaterialTheme.typography.bodySmall, modifier = Modifier.weight(1f))
                        IconButton(onClick = { response.id?.let { controller.startEditEmotionResponse(it, response.text) } }) {
                            Icon(Lucide.Pencil, contentDescription = "Editar resposta")
                        }
                        IconButton(onClick = { response.id?.let(controller::deleteEmotionResponse) }) {
                            Icon(Lucide.Trash2, contentDescription = "Remover resposta")
                        }
                    }
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().padding(start = AppSpacing.space48),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                AppTextField(
                    value = controller.emotionResponseDrafts[emotion.id].orEmpty(),
                    onValueChange = { controller.updateEmotionResponseDraft(emotion.id, it) },
                    label = "Nova resposta",
                    modifier = Modifier.weight(1f),
                    enabled = !responseLimitReached,
                )
                AppButton(
                    text = "Adicionar",
                    onClick = { controller.addEmotionResponse(emotion.id) },
                    enabled =
                        !responseLimitReached &&
                            !controller.emotionBusy &&
                            controller.emotionResponseDrafts[emotion.id]?.isNotBlank() == true,
                )
            }
        }
    }
}

@Composable
private fun CompanyFormDialog(
    mode: CompanyFormMode,
    controller: CompaniesController,
    onNavigate: (Any) -> Unit,
) {
    val typeOptions = CompanyType.entries.map { it.label() }
    val typeByLabel = typeOptions.zip(CompanyType.entries).toMap()
    var passwordVisible by remember { mutableStateOf(false) }
    AppModalCard(
        title =
            stringResource(
                if (mode == CompanyFormMode.Add) Res.string.companies_form_add_title else Res.string.companies_form_edit_title,
            ),
        onDismiss = controller::dismissForm,
    ) {
        Text(
            text = "Etapa ${controller.formStep + 1} de 3",
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        when (controller.formStep) {
            0 -> {
                CompanyTextField(
                    value = controller.formName,
                    onValueChange = { controller.formName = it },
                    label = stringResource(Res.string.companies_field_trade_name),
                )
                CompanyTextField(
                    value = controller.formLegalName,
                    onValueChange = { controller.formLegalName = it },
                    label = stringResource(Res.string.companies_field_legal_name),
                )
                SearchableSelect(
                    leadingIcon = Lucide.Tag,
                    options = typeOptions,
                    selected = controller.formType.label(),
                    onSelect = { label -> typeByLabel[label]?.let { controller.formType = it } },
                    modifier = Modifier.fillMaxWidth(),
                    underlined = true,
                )
                CompanyTextField(
                    value = controller.formLogo,
                    onValueChange = { controller.formLogo = it },
                    label = stringResource(Res.string.companies_field_logo),
                )
                CompanyTextField(
                    value = controller.formLogin,
                    onValueChange = { controller.formLogin = it },
                    label = "Login da empresa",
                )
                CompanyTextField(
                    value = controller.formPassword,
                    onValueChange = { controller.formPassword = it },
                    label = if (mode == CompanyFormMode.Add) "Senha da empresa (mínimo 6 caracteres)" else "Nova senha (mínimo 6 caracteres, opcional)",
                    visualTransformation = if (passwordVisible) VisualTransformation.None else PasswordVisualTransformation(),
                    trailingIcon = {
                        IconButton(onClick = { passwordVisible = !passwordVisible }) {
                            Icon(
                                imageVector = if (passwordVisible) Lucide.EyeOff else Lucide.Eye,
                                contentDescription = if (passwordVisible) "Ocultar senha" else "Mostrar senha",
                            )
                        }
                    },
                )
            }

            1 -> {
                CompanyTextField(
                    value = controller.formEmail,
                    onValueChange = { controller.formEmail = it },
                    label = stringResource(Res.string.companies_field_email),
                )
                CompanyTextField(
                    value = controller.formCommercialPhone,
                    onValueChange = controller::updateCommercialPhone,
                    label = stringResource(Res.string.companies_field_commercial_phone),
                )
                CompanyTextField(
                    value = controller.formMobilePhone,
                    onValueChange = controller::updateMobilePhone,
                    label = stringResource(Res.string.companies_field_mobile_phone),
                )
                CompanyTextField(
                    value = controller.formCnpj,
                    onValueChange = controller::updateCnpj,
                    label = stringResource(Res.string.companies_field_cnpj),
                )
                CompanyNumberField(
                    value = controller.formEmployeeCount,
                    onValueChange = { controller.formEmployeeCount = it },
                    label = stringResource(Res.string.companies_field_employee_count),
                )
                CompanyTextField(
                    value = controller.formCep,
                    onValueChange = controller::updateCep,
                    label = stringResource(Res.string.companies_field_cep),
                )
                if (controller.cepLoading) {
                    Text(
                        text = stringResource(Res.string.companies_cep_loading),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                CompanyTextField(
                    value = controller.formStreet,
                    onValueChange = { controller.formStreet = it },
                    label = stringResource(Res.string.companies_field_street),
                )
                CompanyTextField(
                    value = controller.formNumber,
                    onValueChange = { controller.formNumber = it },
                    label = stringResource(Res.string.companies_field_number),
                )
                CompanyTextField(
                    value = controller.formNeighborhood,
                    onValueChange = { controller.formNeighborhood = it },
                    label = stringResource(Res.string.companies_field_neighborhood),
                )
                CompanyTextField(
                    value = controller.formCity,
                    onValueChange = { controller.formCity = it },
                    label = stringResource(Res.string.companies_field_city),
                )
                CompanyTextField(
                    value = controller.formState,
                    onValueChange = { controller.formState = it },
                    label = stringResource(Res.string.companies_field_state),
                )
            }

            else -> {
                CompanyNumberField(
                    value = controller.formLeftoverMeals,
                    onValueChange = { controller.formLeftoverMeals = it },
                    label = stringResource(Res.string.companies_field_leftover_meals),
                )
                Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                    Text(
                        text = stringResource(Res.string.companies_field_line),
                        style = MaterialTheme.typography.labelMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                    SearchableSelect(
                        leadingIcon = Lucide.Tag,
                        options = LineOptions,
                        selected = controller.formLine,
                        onSelect = { controller.formLine = it },
                        modifier = Modifier.fillMaxWidth(),
                        underlined = true,
                    )
                }
                CompanyNumberField(
                    value = controller.formButtonCount,
                    onValueChange = { controller.formButtonCount = it },
                    label = stringResource(Res.string.companies_field_button_count),
                )
                CompanyNumberField(
                    value = controller.formShortAutoSendTime,
                    onValueChange = { controller.formShortAutoSendTime = it },
                    label = stringResource(Res.string.companies_field_short_auto_send_time),
                )
                CompanyNumberField(
                    value = controller.formLongAutoSendTime,
                    onValueChange = { controller.formLongAutoSendTime = it },
                    label = stringResource(Res.string.companies_field_long_auto_send_time),
                )
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Text(
                        text = stringResource(Res.string.companies_field_comment_all_ratings),
                        style = MaterialTheme.typography.bodyMedium,
                    )
                    Switch(
                        checked = controller.formCommentAllRatings,
                        onCheckedChange = { controller.formCommentAllRatings = it },
                    )
                }
                CompanyTextField(
                    value = controller.formAdminOthersPercent,
                    onValueChange = controller::updateAdminOthersPercent,
                    label = stringResource(Res.string.companies_field_admin_others_percent),
                )
                if (controller.hasInvalidAdminOthersPercent) {
                    Text(
                        text = stringResource(Res.string.companies_invalid_percent),
                        color = MaterialTheme.colorScheme.error,
                        style = MaterialTheme.typography.bodySmall,
                    )
                }
                if (controller.hasInvalidNumericFields) {
                    Text(
                        text = stringResource(Res.string.companies_invalid_number),
                        color = MaterialTheme.colorScheme.error,
                        style = MaterialTheme.typography.bodySmall,
                    )
                }
            }
        }
        if (mode == CompanyFormMode.Edit) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
            ) {
                Text(
                    text = stringResource(Res.string.companies_management_hint),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                )
                AppButton(
                    text = stringResource(Res.string.companies_go_to_org_chart),
                    onClick = {
                        controller.dismissForm()
                        onNavigate(OrgChartRoute)
                    },
                    variant = PortalButtonVariant.Text,
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.companies_cancel),
                onClick = controller::dismissForm,
                variant = PortalButtonVariant.Text,
            )
            if (controller.formStep > 0) {
                AppButton(
                    text = "Voltar",
                    onClick = controller::previousFormStep,
                    variant = PortalButtonVariant.Text,
                )
            }
            if (controller.formStep < 2) {
                AppButton(
                    text = "Próximo",
                    onClick = controller::nextFormStep,
                    enabled = controller.canAdvanceForm,
                    variant = PortalButtonVariant.Filled,
                )
            } else {
                AppButton(
                    text = stringResource(Res.string.companies_save),
                    onClick = controller::submitForm,
                    enabled = controller.isFormConfirmEnabled && !controller.busy,
                    variant = PortalButtonVariant.Filled,
                )
            }
        }
    }
}

@Composable
private fun CompanyTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    visualTransformation: androidx.compose.ui.text.input.VisualTransformation = androidx.compose.ui.text.input.VisualTransformation.None,
    trailingIcon: @Composable (() -> Unit)? = null,
) {
    AppTextField(
        value = value,
        onValueChange = onValueChange,
        label = label,
        modifier = Modifier.fillMaxWidth(),
        visualTransformation = visualTransformation,
        trailingIcon = trailingIcon,
    )
}

@Composable
private fun CompanyNumberField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
) {
    CompanyTextField(
        value = value,
        onValueChange = { input -> onValueChange(input.filter(Char::isDigit)) },
        label = label,
    )
}

@Composable
private fun CompanyDetailsDialog(
    company: Company,
    onDismiss: () -> Unit,
) {
    AppModalCard(
        title = stringResource(Res.string.companies_details_title),
        onDismiss = onDismiss,
    ) {
        DetailRow(stringResource(Res.string.companies_field_trade_name), company.name)
        DetailRow(stringResource(Res.string.companies_field_legal_name), company.legalName)
        DetailRow(stringResource(Res.string.companies_field_type), company.type.label())
        DetailRow(stringResource(Res.string.companies_field_logo), company.logo)
        DetailRow(stringResource(Res.string.companies_field_email), company.email)
        DetailRow(stringResource(Res.string.companies_field_commercial_phone), company.commercialPhone)
        DetailRow(stringResource(Res.string.companies_field_mobile_phone), company.mobilePhone)
        DetailRow(stringResource(Res.string.companies_field_cnpj), company.cnpj)
        DetailRow(stringResource(Res.string.companies_field_employee_count), company.employeeCount.toString())
        DetailRow(stringResource(Res.string.companies_field_cep), company.cep)
        DetailRow(stringResource(Res.string.companies_field_street), company.street)
        DetailRow(stringResource(Res.string.companies_field_number), company.number)
        DetailRow(stringResource(Res.string.companies_field_neighborhood), company.neighborhood)
        DetailRow(stringResource(Res.string.companies_field_city), company.city)
        DetailRow(stringResource(Res.string.companies_field_state), company.state)
        DetailRow(stringResource(Res.string.companies_field_leftover_meals), company.leftoverMeals.toString())
        DetailRow(stringResource(Res.string.companies_field_line), company.line)
        DetailRow(stringResource(Res.string.companies_field_button_count), company.buttonCount.toString())
        DetailRow(stringResource(Res.string.companies_field_short_auto_send_time), company.shortAutoSendTime.toString())
        DetailRow(stringResource(Res.string.companies_field_long_auto_send_time), company.longAutoSendTime.toString())
        DetailRow(stringResource(Res.string.companies_field_direction), company.directorNames.joinToString(", "))
        DetailRow(stringResource(Res.string.companies_field_management), company.managerNames.joinToString(", "))
        DetailRow(stringResource(Res.string.companies_col_updated_by), company.updatedBy)
        DetailRow(stringResource(Res.string.companies_col_updated_at), formatUpdatedAt(company.updatedAt))
    }
}

@Composable
private fun DetailRow(
    label: String,
    value: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = value,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

private fun formatUpdatedAt(value: String): String {
    if (value.length < 10 || value[4] != '-' || value[7] != '-') return value
    val date = "${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)}"
    if (value.length < 16 || value[10] != 'T') return date
    return "$date às ${value.substring(11, 16)}"
}

@Composable
private fun ConfirmDialog(
    title: String,
    message: String,
    confirmLabel: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    AppModalCard(title = title, onDismiss = onDismiss) {
        Text(
            text = message,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.companies_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = confirmLabel,
                onClick = onConfirm,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun CompanyType.label(): String =
    when (this) {
        CompanyType.UPR -> stringResource(Res.string.companies_type_upr)
        CompanyType.TRA -> stringResource(Res.string.companies_type_tra)
        CompanyType.LOJ -> stringResource(Res.string.companies_type_loj)
        CompanyType.EVENTOS -> stringResource(Res.string.companies_type_eventos)
    }

private fun CompanyType.badgeColors(): Pair<Color, Color> =
    when (this) {
        CompanyType.UPR -> AppPalette.Warning100 to AppPalette.Warning900
        CompanyType.TRA -> AppPalette.Success100 to AppPalette.Success900
        CompanyType.LOJ -> AppPalette.Error100 to AppPalette.Error900
        CompanyType.EVENTOS -> AppPalette.Info100 to AppPalette.Info900
    }
